import { availFloors } from "./data";
import anime from "animejs";

const options = {
	isOverlayOpen: false,
	currentPlan: 0,
	imageDiv: null,
	planThumbs: [],
	selectorDiv: null,
	planTitle: null,
	planDl: null,
	isBusy: false,
	canPan: false,
	overlayDiv: null,
	overlayGreyout: null,
	overlayImg: null,
	zoom: {
		current: 1,
		max: 2,
		min: 0.6,
		default: 1,
		rate: 0.4
	},
	imagePan: {
		deltaX: 0,
		deltaY: 0,
		drag: {
			elem: null,
			x: 0,
			y: 0,
			state: false
		},
		delta: {
			x: 0,
			y: 0
		}
	}
};

export function InitPlanView(params) {
	CleanUpPlanView();
	if (params.floorPlanView !== undefined && params.floorPlanView) {
		CleanUpPlanView();
		options.imageDiv = params.floorPlanView.querySelector(".floor-plan-img");
		options.planTitle = params.floorPlanView.querySelector(
			".floor-plan-heading"
		);
		options.selectorDiv = params.floorSelector;
		options.selectorDiv.innerHTML = "";

		options.overlayDiv = params.overlay;
		options.overlayImg = params.overlay.querySelector(".overlay-image");
		options.overlayGreyout = params.overlay.querySelector(".overlay-greyout");

		options.planTitle = params.floorPlanView.querySelector(
			".floor-plan-heading"
		);
		options.planDl = params.floorPlanView.querySelector(".download-plan-link");

		availFloors.map((floor, i) => {
			const li = document.createElement("li");
			li.classList.add("floor-selector");
			li.addEventListener("click", () => JumpToPlan(i));
			// const floorImgDiv = document.createElement("div");
			// floorImgDiv.classList.add("floor-selector-img");
			// floorImgDiv.style.backgroundImage = `url(./images/${floor.thumbImg})`;
			// floorImgDiv.style.backgroundSize = "cover";
			const floorSelectorContentDiv = document.createElement("div");
			floorSelectorContentDiv.classList.add("floor-selector-content");
			floorSelectorContentDiv.innerHTML = `<div class="floor-selector-text">${floor.floor.toUpperCase()} FLOOR </div>
            <div class="floor-selector-text dark-text">${
							floor.size
						} SQ FT</div> <div class="floor-selector-text dark-text">${
							floor.availability
						}</div>`;
			const galleryIconDiv = document.createElement("div");
			// galleryIconDiv.classList.add("floor-gallery-icon");
			// galleryIconDiv.addEventListener("click", () => ShowOverlay(i));
			// li.appendChild(floorImgDiv);
			li.appendChild(floorSelectorContentDiv);
			// li.appendChild(galleryIconDiv);
			options.selectorDiv.appendChild(li);
			options.planThumbs.push(li);
		});

		options.canPan = true;
		options.imagePan.drag.elem = options.imageDiv;

		options.imageDiv.addEventListener("mousedown", DragStart);
		options.imageDiv.addEventListener("mousemove", IsDragging);
		document.addEventListener("mouseup", DragStop);

		JumpToPlan(options.currentPlan);
	}
}

function JumpToPlan(index) {
	options.currentPlan = index;

	options.planThumbs.map(thumb =>
		thumb.classList.remove("floor-selector-active")
	);
	options.planThumbs[index].classList.add("floor-selector-active");
	options.imageDiv.style.backgroundImage = `url(./images/floorplans/${
		availFloors[index].plan
	})`;

	options.planTitle.innerHTML = `${availFloors[
		index
	].floor.toUpperCase()} FLOOR <br /><span class="dark-text">PLAN</span>`;
	options.planDl.href = `dl/${availFloors[index].dl}`;
}

function ShowOverlay(index) {
	if (options.isBusy) {
		return;
	}
	options.isBusy = true;
	options.overlayImg.style.backgroundImage = `url(./images/${
		availFloors[index].img
	})`;
	options.overlayImg.style.backgroundSize = "cover";
	options.overlayDiv.classList.remove("hidden");

	const timeline = new anime.timeline();

	timeline
		.add({
			targets: options.overlayGreyout,
			opacity: [0, 0.7],
			duration: 200,
			easing: "easeOutQuad"
		})
		.add({
			targets: options.overlayImg,
			opacity: [0, 1],
			duration: 200,
			easing: "easeOutQuad",
			complete: () => {
				options.isBusy = false;
			}
		});
}

export function HideOverlay() {
	if (options.isBusy) {
		return;
	}
	options.isBusy = true;
	const timeline = new anime.timeline();

	timeline
		.add({
			targets: options.overlayImg,
			opacity: [1, 0],
			duration: 200,
			easing: "easeInQuad"
		})
		.add(
			{
				targets: options.overlayGreyout,
				opacity: [0.7, 0],
				duration: 200,
				easing: "easeInQuad",
				complete: () => {
					options.overlayDiv.classList.add("hidden");
					options.isBusy = false;
				}
			},
			0
		);
}

function CleanUpPlanView() {
	options.canPan = false;
	if (options.selectorDiv !== null) {
		options.selectorDiv.innerHTML = "";
		options.selectorDiv = null;
	}
	options.planThumbs = [];
}

export function ZoomIn() {
	if (options.isBusy) {
		return;
	}

	if (options.zoom.current + options.zoom.rate > options.zoom.max) {
		return;
	}

	options.isBusy = true;
	options.zoom.current = options.zoom.current + options.zoom.rate;

	ZoomAnim();
}

export function ZoomOut() {
	if (options.isBusy) {
		return;
	}

	if (options.zoom.current - options.zoom.rate < options.zoom.min) {
		return;
	}

	options.isBusy = true;
	options.zoom.current = options.zoom.current - options.zoom.rate;

	ZoomAnim();
}

export function ZoomReset() {
	if (options.isBusy) {
		return;
	}

	options.isBusy = true;
	options.zoom.current = options.zoom.default;

	anime({
		targets: options.imageDiv,
		top: "0px",
		left: "0px",
		easing: "easeInOutQuad",
		duration: 200,
		complete: () => {
			options.imageDiv.style.top = "0px";
			options.imageDiv.style.left = "0px";
		}
	});

	ZoomAnim();
}

function ZoomAnim() {
	anime({
		targets: options.imageDiv,
		scale: options.zoom.current,
		duration: 200,
		easing: "easeOutQuad",
		complete: () => {
			options.isBusy = false;
		}
	});
}

function DragStart(e) {
	if (!options.imagePan.drag.state && e.which === 1) {
		if (e.target.classList[0] === options.imageDiv.classList[0]) {
			options.imagePan.drag.elem = options.imageDiv;
		} else {
			return;
		}
		options.imagePan.drag.x = e.pageX;
		options.imagePan.drag.y = e.pageY;
		options.imagePan.drag.state = true;
	}
	return false;
}

function IsDragging(e) {
	if (options.imagePan.drag.state) {
		options.imagePan.delta.x = e.pageX - options.imagePan.drag.x;
		options.imagePan.delta.y = e.pageY - options.imagePan.drag.y;

		const imagePanStyle = {
			left: options.imagePan.drag.elem.style.left.substr(
				0,
				options.imagePan.drag.elem.style.left.length - 2
			),
			top: options.imagePan.drag.elem.style.top.substr(
				0,
				options.imagePan.drag.elem.style.top.length - 2
			)
		};

		options.imagePan.drag.elem.style.left = `${parseInt(imagePanStyle.left) +
			options.imagePan.delta.x}px`;
		options.imagePan.drag.elem.style.top = `${parseInt(imagePanStyle.top) +
			options.imagePan.delta.y}px`;

		options.imagePan.drag.x = e.pageX;
		options.imagePan.drag.y = e.pageY;

		options.imagePan.drag.elem.style.cursor = "grabbing";
	}
}

function DragStop() {
	if (options.imagePan.drag.state) {
		options.imagePan.drag.state = false;
		options.imagePan.drag.elem.style.cursor = "grab";
	}
}



// WEBPACK FOOTER //
// ./src/planView.js